var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 6'%3e%3cpath fill='%23009B3A' d='M0 0h12v6H0'/%3e%3cpath stroke='%23FED100' d='M-6 9 18-3V9L-6-3'/%3e%3c/svg%3e";
  export default img;